import { Controller } from "@hotwired/stimulus"

import { ExtensionClient } from "../extension/client"
import type { ExtensionConfig } from "../extension/client.types"

declare global {
  interface Window {
    ExtensionClient?: typeof ExtensionClient
  }
}

export default class extends Controller {
  static values = { config: Object, isDebug: Boolean }

  declare readonly configValue: ExtensionConfig
  declare readonly isDebugValue: boolean

  connect() {
    ExtensionClient.initialize(this.configValue)
    // Convenience handle for admins to poke at the client from the console.
    if (this.isDebugValue) window.ExtensionClient = ExtensionClient
  }
}
